
import Glide from '@glidejs/glide'

export default (autoplay = false) => {
  return {
    slider: null,
    options: {
      type: 'carousel',
      gap: 0,
      rewind: true,
      autoplay: autoplay,
      focusAt: 'center',
      peek: 600,
      breakpoints: {
        500: {
          peek: 80,
        },
        600: {
          peek: 150,
        },
        900: {
          peek: 180,
        },
        1024: {
          peek: 280,
        },
        1200: {
          peek: 320,
        },
        1400: {
          peek: 350,
        },
        1600: {
          peek: 450,
        },
        1900: {
          peek: 500,
        },
      },
    },
    title: '',
    link: '',
    categories: '',
    activeClasses: {
      imageContainer: '-rotate-45 opacity-100 z-10',
      image: 'rotate-45 max-w-initial object-cover scale-150',
    },
    animation: '',
    prevString: '<',
    nextString: '>',
    mountSlider() {
      this.slider = new Glide(this.$refs.slider, this.options)
      this.slider.mount()
      this.animation = this.options.autoplay ? 'before:animate-background-fill' : ''
      this.prevString = this.prevString ?? '<'
      this.nextString = this.nextString ?? '>'
      this.slider.on(['move'], () => {
        this.animation = 'before:invisible before:animate-none'
      })
      this.slider.on(['move.after'], () => {
        this.animation = 'before:animate-background-fill'
      })
      this.slider.on(['resize'], () => {
        this.slider.update()
      })
    },
    prev() {
      this.slider.go('<');
    },
    next() {
      this.slider.go('>')
    },
    get activeSlide() {
      return this.slider?.index.toString() ? this.slider.index : null
    },
    getItemData(index = 0, title, link, categories) {
      this.title = this.activeSlide === index && title ? title : this.title
      this.link = this.activeSlide === index && link ? link : this.link
      this.categories = this.activeSlide === index ? categories : this.categories
    },
  }
}
